module.exports = __webpack_public_path__ + "fe006bdc0e5e8b2a6dc19c1a107d36ab.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PN.svg
// module id = lKtd
// module chunks = 0